import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft } from "react-icons/bi";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import StaticDocumentFields from "../../shared/StaticDocumentFields";
import useStaticDocumentForm from "../../shared/useStaticDocumentForm";

const View = ({ onSubmit, cancel, loading }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const FORM = t("STATIC.FORM", { returnObjects: true });
  const form = useStaticDocumentForm({ fileRequired: true });

  return (
    <>
      <Header
        title={FORM.CREATE_TITLE}
        actions={[
          {
            text: FORM.BACK,
            onClick: cancel,
            type: "primary--outlined",
            icon: <BiChevronLeft size={20} />,
          },
          {
            text: FORM.SAVE,
            onClick: () => onSubmit(form.data()),
            type: "primary",
            icon: <BiCheck size={20} />,
            disabled: !form.isValid || loading,
            loading,
          },
        ]}
      />
      <StaticDocumentFields form={form} />
    </>
  );
};

export default View;
